import cart from './cart.vue';

export default {
  components: {
    cart,
  },
};
